import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProductZoom from "../../components/ProductZoom";
import { useLazyOwnerListQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const BankAccountView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [details, setDetails] = useState({});
  const [transaction, settransaction] = useState({});
  const [booking, setbooking] = useState({});
  const [subscription, setsubscription] = useState({});
  const [recommendation, setrecommendation] = useState({});
  const [wallet, setwallet] = useState({});

  //RTK QUERY
  const [viewApi] = useLazyOwnerListQuery();

  // DETAILS VIEW
  const getView = () => {
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setbooking(res?.owner);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"bank-accounts-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Bank Details
                </th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>Booking ID</td>
                  <td>:</td>
                  <td>
                    {booking?.bank?.bank_name ? booking?.bank?.bank_name : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Bank Branch</td>
                  <td>:</td>
                  <td>{booking?.bank?.branch ? booking?.bank?.branch : "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Account Holder Name</td>
                  <td>:</td>
                  <td>
                    {booking?.bank?.account_holder_name
                      ? booking?.bank?.account_holder_name
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Account No</td>
                  <td>:</td>
                  <td>
                    {booking?.bank?.account_number
                      ? booking?.bank?.account_number
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Ifsc Code</td>
                  <td>:</td>
                  <td>
                    {booking?.bank?.ifsc_code ? booking?.bank?.ifsc_code : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>UPI ID</td>
                  <td>:</td>
                  <td>{booking?.bank?.upi_id ? booking?.bank?.upi_id : "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Gpay Number</td>
                  <td>:</td>
                  <td>
                    {booking?.bank?.gpay_number
                      ? booking?.bank?.gpay_number
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Phone Pay Number</td>
                  <td>:</td>
                  <td>
                    {booking?.bank?.phonepe_number
                      ? booking?.bank?.phonepe_number
                      : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankAccountView;
